import React, { useEffect, useState, } from "react";
import { BrowserRouter as Router, Redirect } from "react-router-dom";
import { renderRoutes } from "react-router-config";
import { useSelector } from 'react-redux';
import RouteMenu from './routes';

const RouterCreate = () => {
  const { isLoggedIn, user } = useSelector(state => {
    return {
      isLoggedIn: state.auth.login,
      user: state.auth.loginResponse || {}
    };
  });
  let isLoggedInState = isLoggedIn;
  const RouteMenuData = RouteMenu();
  let routes = RouteMenuData.getRoutes();

  const { pathname, search } = window.location;
  const [path, setPath] = useState(pathname + search);
  let params = new URLSearchParams(search);
  let isResetPassword = params.get("step") === 'resetPassword' && pathname === '/login'; // 在login page 同时step为resetPassword则认定为需要重置密码
  if (isResetPassword) {
    // 重置密码时，将用户登录状态设置为未登录
    isLoggedInState = false;
  }

  let redirect = params.get("redirect");
  const defaultPath = '/home/admin/users';
  useEffect(() => {
    let unmounted = false;
    if (!unmounted) {
      setPath(pathname === '/' ? defaultPath : path);
    }
    // eslint-disable-next-line no-return-assign
    return () => (unmounted = true);
  }, [path]);

  // 如果狀態為已登錄，則每次跳轉頁面前（包括重定向和正常跳轉），都先進行遞歸檢測

  if (isLoggedInState && user.user?.role) {
    if (!user.user.authorizedService.includes(3)) {
      redirect = '/401';
    } else {
      let find = false;
      // 有重定向則檢查重定向，否則則是跳轉頁面，因為重定向優先級更高
      let checkpath = redirect || pathname;
      if (!redirect && pathname === '/login') {
        redirect = defaultPath
      }
      // 遞歸檢測所有路由，如果目標頁面不在路由中（沒權限的頁面已經從路由中過濾，這時的路由已經是有權限的了），則跳轉到/home/my/wines
      const splitPath = checkpath.split('/');
      let helpher = routelist => {
        if (!find) {
          routelist.map(item => {
            if (checkpath === item.path) {
              // path全等，則放行
              find = true;
            } else if (item.path.indexOf(':') >= 0) {
              // 不全等，得看看是不是動態路由,是的話，就拆分逐一匹配
              const itemPathSplit = item.path.split('/');
              let checkSuccess = true;
              for (let i = 0; i < itemPathSplit.length; i++) {
                let pi = itemPathSplit[i];
                let si = splitPath[i];
                if (pi.indexOf(':') < 0 && pi !== si) {
                  checkSuccess = false;
                  break;
                }
              }
              if (checkSuccess) {
                // console.log('匹配成功', item.path, checkpath)
                find = true;
              }
            }
            item.routes?.length && helpher(item.routes)
          })
        }
      }
      helpher(routes);
      if (!find) {
        // 頁面不在路由中，重定向到這
        redirect = defaultPath
      }
    }
  }
  // 用戶登錄且打開了login頁面，直接回到首頁，因為他狀態是已登錄
  // if (isLoggedInState && path === '/login') setPath(defaultPath);
  // login頁面的默認路徑
  let defaultLoginPath = "/login" + search
  // 如果未登錄且不在login頁，則把當前頁作為登錄後的重定向頁面以參數形式跳轉到login，形式為：/login?redirect=未登錄時訪問的path

  if (!isLoggedInState && pathname !== '/login' && pathname !== '/' && pathname !== '/401') defaultLoginPath = "/login?redirect=" + encodeURIComponent(pathname + search);
  return (
    <Router basename={process.env.PUBLIC_URL}>
      {/* 登錄且有重定向，則跳轉到重定向的頁面 */}
      {isLoggedInState && redirect && <Redirect to={redirect} />}
      {/* 路由 */}
      {renderRoutes(routes)}
      {/* 未登錄前往登錄頁 */}
      {!isLoggedInState && <Redirect to={defaultLoginPath} />}
    </Router>
  );
}

export default RouterCreate;